import _defineProperty from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { forwardRef, useRef, useState, useEffect } from 'react';
import { useReducedMotion, useUncontrolled, useUuid, useResizeObserver, useIsomorphicEffect, useMergedRef } from '@mantine/hooks';
import { useMantineDefaultProps } from '@mantine/styles';
import useStyles, { WRAPPER_PADDING } from './SegmentedControl.styles.js';
import { Box } from '../Box/Box.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

var defaultProps = {
  disabled: false,
  size: "sm",
  transitionDuration: 200
};
var SegmentedControl = forwardRef(function (props, ref) {
  var _b, _c;

  var _a = useMantineDefaultProps("SegmentedControl", defaultProps, props),
      className = _a.className,
      disabled = _a.disabled,
      _data = _a.data,
      name = _a.name,
      value = _a.value,
      onChange = _a.onChange,
      color = _a.color,
      fullWidth = _a.fullWidth,
      radius = _a.radius,
      size = _a.size,
      transitionDuration = _a.transitionDuration,
      transitionTimingFunction = _a.transitionTimingFunction,
      classNames = _a.classNames,
      styles = _a.styles,
      defaultValue = _a.defaultValue,
      orientation = _a.orientation,
      others = __objRest(_a, ["className", "disabled", "data", "name", "value", "onChange", "color", "fullWidth", "radius", "size", "transitionDuration", "transitionTimingFunction", "classNames", "styles", "defaultValue", "orientation"]);

  var reduceMotion = useReducedMotion();

  var data = _data.map(function (item) {
    return typeof item === "string" ? {
      label: item,
      value: item
    } : item;
  });

  var mounted = useRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      shouldAnimate = _useState2[0],
      setShouldAnimate = _useState2[1];

  var _useUncontrolled = useUncontrolled({
    value: value,
    defaultValue: defaultValue,
    finalValue: Array.isArray(data) ? (_c = (_b = data.find(function (item) {
      return !item.disabled;
    })) == null ? void 0 : _b.value) != null ? _c : data[0].value : null,
    onChange: onChange,
    rule: function rule(val) {
      return !!val;
    }
  }),
      _useUncontrolled2 = _slicedToArray(_useUncontrolled, 2),
      _value = _useUncontrolled2[0],
      handleValueChange = _useUncontrolled2[1];

  var _useStyles = useStyles({
    size: size,
    fullWidth: fullWidth,
    color: color,
    radius: radius,
    shouldAnimate: reduceMotion || !shouldAnimate,
    transitionDuration: transitionDuration,
    transitionTimingFunction: transitionTimingFunction,
    orientation: orientation
  }, {
    classNames: classNames,
    styles: styles,
    name: "SegmentedControl"
  }),
      classes = _useStyles.classes,
      cx = _useStyles.cx,
      theme = _useStyles.theme;

  var _useState3 = useState({
    width: 0,
    height: 0,
    translate: [0, 0]
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      activePosition = _useState4[0],
      setActivePosition = _useState4[1];

  var uuid = useUuid(name);
  var refs = useRef({});

  var _useResizeObserver = useResizeObserver(),
      _useResizeObserver2 = _slicedToArray(_useResizeObserver, 2),
      observerRef = _useResizeObserver2[0],
      containerRect = _useResizeObserver2[1];

  useIsomorphicEffect(function () {
    if (!mounted.current) {
      mounted.current = true;
      setShouldAnimate(false);
    } else {
      setShouldAnimate(true);
    }
  });
  useEffect(function () {
    if (_value in refs.current && observerRef.current) {
      var element = refs.current[_value];
      var elementRect = element.getBoundingClientRect();
      var scaledValue = element.offsetWidth / elementRect.width;
      var width = elementRect.width * scaledValue || 0;
      var height = elementRect.height * scaledValue || 0;
      var offsetRight = containerRect.width - element.parentElement.offsetLeft + WRAPPER_PADDING - width;
      var offsetLeft = element.parentElement.offsetLeft - WRAPPER_PADDING;
      setActivePosition({
        width: width,
        height: height,
        translate: [theme.dir === "rtl" ? offsetRight : offsetLeft, element.parentElement.offsetTop - WRAPPER_PADDING]
      });
    }
  }, [_value, containerRect]);
  var controls = data.map(function (item) {
    var _cx2;

    return /* @__PURE__ */React.createElement("div", {
      className: cx(classes.control, _defineProperty({}, classes.controlActive, _value === item.value)),
      key: item.value
    }, /* @__PURE__ */React.createElement("input", {
      className: classes.input,
      disabled: disabled || item.disabled,
      type: "radio",
      name: uuid,
      value: item.value,
      id: "".concat(uuid, "-").concat(item.value),
      checked: _value === item.value,
      onChange: function onChange() {
        return handleValueChange(item.value);
      }
    }), /* @__PURE__ */React.createElement("label", {
      className: cx(classes.label, (_cx2 = {}, _defineProperty(_cx2, classes.labelActive, _value === item.value), _defineProperty(_cx2, classes.disabled, disabled || item.disabled), _cx2)),
      htmlFor: "".concat(uuid, "-").concat(item.value),
      ref: function ref(node) {
        refs.current[item.value] = node;
      }
    }, item.label));
  });
  return /* @__PURE__ */React.createElement(Box, __spreadValues({
    className: cx(classes.root, className),
    ref: useMergedRef(observerRef, ref)
  }, others), !!_value && shouldAnimate && /* @__PURE__ */React.createElement(Box, {
    component: "span",
    className: classes.active,
    sx: {
      width: activePosition.width,
      height: activePosition.height,
      transform: "translate(".concat(activePosition.translate[0], "px, ").concat(activePosition.translate[1], "px )")
    }
  }), controls);
});
SegmentedControl.displayName = "@mantine/core/SegmentedControl";
export { SegmentedControl };